import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit, Renderer2 } from '@angular/core'
import { InfoPopupService } from '../../../services/info-popup.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { AppType } from '../../../types/app.type'

@Component({
  selector: 'bmcore-info-popup',
  templateUrl: './bmcore-info-popup.component.html',
  styleUrls: ['./bmcore-info-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreInfoPopupComponent implements OnInit {
  @Input() appType: AppType

  isPopupOpen = false
  text: string

  lg: LgType

  constructor(
    private infoPopupService: InfoPopupService,
    private renderer: Renderer2,
    private i18nService: I18nService
  ) {}

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closePopup()
    }
  }

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()

    this.infoPopupService.showInfoPopup.subscribe(text => {
      // No parent scroll on modal scroll
      this.renderer.addClass(document.body, 'modal-open')
      this.isPopupOpen = true
      this.text = text
    })
  }

  closePopup() {
    this.isPopupOpen = false
    this.renderer.removeClass(document.body, 'modal-open')
  }
}
